/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import { useAppKontoContext } from "../../../../Basis/Components/AppKontoContext";
import { useAppMandantContext } from "../../../../Basis/Components/AppMandantContext";
import ErrorText from "../../../../Basis/Components/ErrorText";
import ProvisionHinweis from "../../../../Basis/Components/ProvisionHinweis";
import StripeSepaElement from "../../../../Basis/Components/StripeSepaElement";
import LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss from "../../../../Management/Mandanten/Queries/LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss";
import useZahlungsmethodeAendern from "../../../../Management/Mandanten/Utils/useZahlungsmethodeAendern";
import VollstaendigerName from "../../../../Management/Mandanten/Utils/VollstaendigerName";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nEinstellungen";
import ActionsBar from "./ActionsBar";
import { useSchnelleinstiegContext } from "./SchnelleinstiegContext";
import SchrittHeader from "./SchrittHeader";
import SchrittText from "./SchrittText";
import SchrittTitel from "./SchrittTitel";

export default function SchnelleinstiegZahlungsmethode() {
    const { t } = useTranslation();
    const { WeiterButton } = useSchnelleinstiegContext();
    const [anzahlTageBisZahlungsmethodeGesetztSeinMuss, setAnzahlTageBisZahlungsmethodeGesetztSeinMuss] = useState<number>(1);
    const [isComplete, setIsComplete] = useState<boolean>(false);
    new LadeAnzahlTageBisZahlungsmethodeGesetztSeinMuss((anzahlTage) => setAnzahlTageBisZahlungsmethodeGesetztSeinMuss(anzahlTage.anzahlTage));

    const [zahlungsmethodeAendern, error] = useZahlungsmethodeAendern();
    const mandant = useAppMandantContext().mandant;
    const konto = useAppKontoContext().konto;
    const [vollstaendigerName, setVollstaendigerName] = useState(VollstaendigerName.von(konto?.kontoAdressen[0].vorname, konto?.kontoAdressen[0].nachname));

    return (
        <>
            <SchrittHeader>
                <SchrittTitel>
                    {t(translationKeys.schnelleinstiegZahlungsmethode.titel)}
                </SchrittTitel>
            </SchrittHeader>

            <SchrittText>
                {anzahlTageBisZahlungsmethodeGesetztSeinMuss <= 0
                    ? t(translationKeys.schnelleinstiegZahlungsmethode.text_jetzt)
                    : t(translationKeys.schnelleinstiegZahlungsmethode.text, { count: anzahlTageBisZahlungsmethodeGesetztSeinMuss })}
            </SchrittText>

            <ProvisionHinweis color="textSecondary" variant="subtitle1" sx={{ mb: 2 }} />

            <StripeSepaElement
                onChange={(isComplete, fullName) => {
                    setIsComplete(isComplete);
                    setVollstaendigerName(new VollstaendigerName(fullName))
                }}
                fullName={vollstaendigerName.toString()}
                required
            />

            <ErrorText errors={error ? [error] : []} />

            <ActionsBar>
                <WeiterButton
                    disabled={!isComplete || !vollstaendigerName.istGueltig()}
                    onClick={async () => {
                        await zahlungsmethodeAendern({
                            fullName: vollstaendigerName.toString(),
                            eMail: konto?.eMail ?? "",
                            land: mandant?.firmendaten.land ?? "",
                            mandantId: mandant?.mandantId ?? "",
                            mandantGeaendert: mandant?.geaendert ?? "",
                        });
                    }}
                />
            </ActionsBar>
        </>
    );
}